import { render } from "./UpgradeToFreelancer.vue?vue&type=template&id=2fd85016&scoped=true"
import script from "./UpgradeToFreelancer.vue?vue&type=script&lang=js"
export * from "./UpgradeToFreelancer.vue?vue&type=script&lang=js"

import "./UpgradeToFreelancer.vue?vue&type=style&index=0&id=2fd85016&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd85016"]])

export default __exports__